import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const serviceDeskServicesWithoutProjectRoute: InvariantJiraRoute = {
	name: 'servicedesk-services-without-project',
	path: '/jira/servicedesk/services',
	exact: true,
};
